export interface ListSummaryItem {
  label: string;
  /** Already formatted — money in the tenant's currency by the caller. */
  value: string;
  tone?: 'brand' | 'success' | 'warning' | 'danger' | 'violet' | 'teal';
}

const TONE: Record<NonNullable<ListSummaryItem['tone']>, string> = {
  brand: 'from-brand-500 to-indigo-500',
  success: 'from-success-500 to-teal-500',
  warning: 'from-warning-500 to-danger-500',
  danger: 'from-danger-500 to-pink-500',
  violet: 'from-violet-500 to-pink-500',
  teal: 'from-teal-500 to-success-500',
};

/**
 * The count and totals of EVERY row the filters match (T27) — not the page on
 * screen, so it agrees with the export to the minor unit.
 */
export function ListSummaryBar({
  items,
  loading,
}: {
  items: ListSummaryItem[];
  loading?: boolean;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="grid grid-cols-2 md:grid-cols-4 gap-3 animate-fade-in"
    >
      {items.map((item) => (
        <div
          key={item.label}
          className="relative overflow-hidden rounded-xl bg-white dark:bg-neutral-800 shadow-md hover:shadow-lg transition-all duration-200 border border-neutral-100 dark:border-neutral-700 px-4 py-3"
        >
          <span
            className={`absolute inset-y-0 left-0 w-1 bg-gradient-to-b ${TONE[item.tone ?? 'brand']}`}
            aria-hidden="true"
          />
          <p className="text-[11px] font-semibold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">
            {item.label}
          </p>
          <p className="mt-0.5 text-lg font-bold tabular-nums text-neutral-900 dark:text-white">
            {loading ? '…' : item.value}
          </p>
        </div>
      ))}
    </div>
  );
}
